// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__WRtWY","title":"FrontImage_title__3z_px"};